import { render, staticRenderFns } from "./productProgress.vue?vue&type=template&id=2be6b66f&scoped=true&"
import script from "./productProgress.vue?vue&type=script&lang=js&"
export * from "./productProgress.vue?vue&type=script&lang=js&"
import style0 from "./productProgress.vue?vue&type=style&index=0&id=2be6b66f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be6b66f",
  null
  
)

export default component.exports